var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("集团组织架构管理")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "background-color": "#f7f8fa",
      "height": "750px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('Structure', {
    ref: "Structure",
    attrs: {
      "condition": _vm.condition,
      "form": _vm.form
    },
    on: {
      "parentFind": _vm.Find
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 1
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icon/迈亚集团icon@2x.png"),
      "height": "22px"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "19px",
      "line-height": "26px",
      "margin-left": "5px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.form.organize_name))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icon/设置@2x.png"),
      "height": "22px"
    },
    on: {
      "click": _vm.EditFrom
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px",
      "padding": "0 40px"
    }
  }, [_c('el-tabs', {
    attrs: {
      "before-leave": _vm.Find
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "下级部门",
      "name": "department"
    }
  }, [_c('department', {
    ref: "department",
    on: {
      "structureFind": _vm.structureFind
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "部门人员",
      "name": "staff"
    }
  }, [_c('staff', {
    ref: "staff",
    on: {
      "structureFind": _vm.structureFind
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("部门编辑")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "width": "2px",
      "border-left": "2px #006E4B solid"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "font-weight": "bold",
      "color": "#000000"
    }
  }, [_vm._v("部门信息")])])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "部门名称",
      "prop": "organize_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入部门名称"
    },
    model: {
      value: (_vm.form.organize_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "organize_name", $$v)
      },
      expression: "form.organize_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门主管",
      "prop": "staff_ids"
    }
  }, [_c('div', {
    on: {
      "click": _vm.setStaff
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "点击设置部门主管",
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.form.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "staff_name", $$v)
      },
      expression: "form.staff_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.condition.flag != 'group'),
      expression: "condition.flag != 'group'"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "width": "2px",
      "border-left": "2px #006E4B solid"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "font-weight": "bold",
      "color": "#000000"
    }
  }, [_vm._v("调整架构级别")])])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "调整架构级别"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.spare5),
      callback: function($$v) {
        _vm.$set(_vm.form, "spare5", $$v)
      },
      expression: "form.spare5"
    }
  }, _vm._l((_vm.organizeLevel), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.condition.flag != 'group'),
      expression: "condition.flag != 'group'"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "width": "2px",
      "border-left": "2px #006E4B solid"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "font-weight": "bold",
      "color": "#000000"
    }
  }, [_vm._v("调整架构")])])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "调整架构"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "props": _vm.props
    },
    model: {
      value: (_vm.form.organize_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "organize_id", $$v)
      },
      expression: "form.organize_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "跨区域调整"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.radio),
      callback: function($$v) {
        _vm.$set(_vm.form, "radio", $$v)
      },
      expression: "form.radio"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.radio),
      callback: function($$v) {
        _vm.$set(_vm.form, "radio", $$v)
      },
      expression: "form.radio"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "实际调整时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.form.years_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "years_date", $$v)
      },
      expression: "form.years_date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.condition.flag != 'group'),
      expression: "condition.flag != 'group'"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticStyle: {
      "height": "20px",
      "width": "2px",
      "border-left": "2px #006E4B solid"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "font-weight": "bold",
      "color": "#000000"
    }
  }, [_vm._v("合并部门")])])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "30px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": "合并部门"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "props": _vm.props
    },
    model: {
      value: (_vm.form.merge_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "merge_id", $$v)
      },
      expression: "form.merge_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Save
    }
  }, [_vm._v("保存\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "40%",
      "center": "",
      "visible": _vm.setStaffVisible,
      "append-to-body": "",
      "close-on-click-modal": false,
      "show-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.setStaffVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("设置部门主管")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "border": "1px solid #EBEEF5"
    }
  }, [_c('setStaff', {
    ref: "setStaff",
    attrs: {
      "type": "checkbox",
      "accordion": false
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['setStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 2)], 2)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a036d0e8","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Jtzzjggl/Jtzzjggl.vue
// module id = null
// module chunks = 